import React from 'react';
import { Box, Typography } from '@mui/material';
import { RiCalendarLine, RiArrowLeftSLine } from 'react-icons/ri';
import StyledBox from 'views/rebranded-module/blogs-module/BlogDetailsViewV2/components/HeaderSection/HeaderSection.styles';
import {
  Typography700,
  ImgBox,
  Share,
} from 'views/rebranded-module/common/components';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import PATHS from 'lib/navigation/paths';
import NavigatorLink from 'views/common/components/Logical/NavigatorLink';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import useLayoutHeights from 'views/rebranded-module/common/hooks/UseLayoutHeight';
import { HeaderSectionProps } from 'views/rebranded-module/blogs-module/BlogDetailsViewV2/components/HeaderSection/HeaderSection.interface';

const HeaderSection: React.FC<HeaderSectionProps> = (props) => {
  const { title, postedDate, coverImage } = props;
  const content = useContent('BlogDetailsPage');
  const getSizedImage = useAdabtiveMultiSizeImage();
  const { LAYOUT_HEIGHT, LAYOUT_HEIGHT_SM } = useLayoutHeights();

  return (
    <StyledBox
      layoutHeight={LAYOUT_HEIGHT}
      smallLayoutHeight={LAYOUT_HEIGHT_SM}>
      <Box className="HSContentContainer">
        <Box className="HSHeaderGrid">
          <Box className="HSBreadcrumbWrapper">
            <NavigatorLink
              href={PATHS.motorcycleTouring.index({})}
              className="HSBackLink">
              <RiArrowLeftSLine className="HSBackLinkIcon" />
              <Typography
                component="span"
                variant="overline1"
                className="HSBackLinkText">
                {content.allPostsLabel}
              </Typography>
            </NavigatorLink>
          </Box>
          <Box className="HSTitleDateWrapper">
            <Box className="HSTitleContainer">
              <Typography700 variant="h3" className="HSTitle" component="h1">
                {title}
              </Typography700>
              {postedDate && (
                <Box className="HSDateWrapper">
                  <RiCalendarLine className="HSDateIcon" />
                  <Typography variant="body1" className="HSDate">
                    {postedDate}
                  </Typography>
                </Box>
              )}
            </Box>

            <Share
              journeyName={title}
              shareModalTitle={content.shareModalTitle}
            />
          </Box>
        </Box>
        {coverImage && (
          <Box className="HSCoverContainer">
            <ImgBox
              image={{
                src: getSizedImage(coverImage),
                alt: title,
              }}
              width="100%"
              height="100%"
              className="HSCoverImage"
            />
          </Box>
        )}
      </Box>
    </StyledBox>
  );
};

export { HeaderSection };
